var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._m(0),_c('div',{staticClass:"elite-content_body_inner_container"},[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elite-content_body_inner_header"},[_c('div',{staticClass:"elite-content_body_inner_header_left"})])
}]

export { render, staticRenderFns }